export default {
    'toolbar.chrome.print': '浏览器打印',
    'toolbar.print': '打印',
    'toolbar.preview': '预览',
    'toolbar.download': '下载',
    'toolbar.clear': '清空',
    'toolbar.save': '保存',
    'toolbar.widget': '控件',
    'toolbar.page': '页面',
    'toolbar.printer.setting': '打印机设置',

    'toolbar.history': '历史',
    'toolbar.setting': '设置',

    'toolbar.style.blob': '加粗',

    'toolbar.style.italic': '倾斜',
    'toolbar.style.underline': '下划线',
    'toolbar.style.lineThrough': '删除线',

    'toolbar.style.textAlignLeft': '左对齐',
    'toolbar.style.textAlignCenter': '水平居中',
    'toolbar.style.alignHorizontalCenter': '居中对齐',
    'toolbar.style.textAlignRight': '右对齐',
    'toolbar.style.verticalAlignTop': '顶对齐',
    'toolbar.style.alignTop': '顶端对齐',
    'toolbar.style.verticalAlignCenter': '垂直居中',
    'toolbar.style.alignVerticalCenter': '垂直居中对齐',
    'toolbar.style.verticalAlignBottom': '底对齐',
    'toolbar.style.alignBottom': '底端对齐',
    'toolbar.style.arrangeHorizontalSpacing': '水平平均分布',
    'toolbar.style.arrangeVerticalSpacing': '垂直平均分布',
    'toolbar.style.lineBreak': '换行',
    'toolbar.style.borderAll': '边框',
    'toolbar.style.group': '组合',
    'toolbar.style.unGroup': '取消组合',

    'toolbar.printer': '打印机',
    'toolbar.layer.top': '置于顶层',
    'toolbar.layer.up.one': '上移一层',
    'toolbar.layer.bottom': '置于底层',
    'toolbar.layer.down.one': '下移一层'

};



